import React from 'react';
import CustomLink from '../CustomLink/CustomLink';

export interface PlaystoreIconsProps {
  google_play_link: string;
  apple_store_link: string;
}

export interface PlaystoreIconsBlokProps {
  blok: PlaystoreIconsProps;
}

const PlaystoreIcons: React.FC<PlaystoreIconsBlokProps> = ({ blok }) => {
  return (
    <div className="flex space-x-6">
      {blok?.google_play_link && (
        <CustomLink url={blok.google_play_link}>
          <div className="bg-[url('/svgs/google-play.svg')] w-[164px] h-[48px] bg-no-repeat" />
        </CustomLink>
      )}
      {blok?.apple_store_link && (
        <CustomLink url={blok.apple_store_link}>
          <div className="bg-[url('/svgs/app-store.svg')] w-[144px] h-[48px] bg-no-repeat" />
        </CustomLink>
      )}
    </div>
  );
};

export default PlaystoreIcons;
